import * as urls from "@/config/analytics/urls";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class url extends Vue {
  get url() {
    return {
      status: urls.MEMCACHIER_STATUS_URL,
      blog: urls.MEMCACHIER_BLOG_URL,
      support: urls.MEMCACHIER_SUPPORT_URL,
      feedback: urls.MEMCACHIER_FEEDBACK_URL,
      twitter: urls.MEMCACHIER_TWITTER_URL,
      github: urls.MEMCACHIER_GITHUB_URL,
      caches: urls.MEMCACHIER_CACHES_URL,
      account: urls.MEMCACHIER_ACCOUNT_URL,
      invoices: urls.MEMCACHIER_INVOICES_URL,
      login: urls.MEMCACHIER_LOGIN_URL,
      logout: urls.MEMCACHIER_LOGOUT_URL,
      signUp: urls.MEMCACHIER_SIGN_UP_URL,
      about: urls.MEMCACHIER_ABOUT_URL,
      contact: urls.MEMCACHIER_CONTACT_URL,
      docs: urls.MEMCACHIER_DOCS_URL,
      docsCredentials: urls.MEMCACHIER_DOCS_CREDENTIALS_URL,
      herokuDashboard: urls.HEROKU_DASHBOARD,
      herokuDocs: urls.HEROKU_DOCS,
      herokuInfo: urls.HEROKU_INFO,
      cachesight: urls.CACHESIGHT_URL,
    };
  }
}
